import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { Box, Stack, Tooltip } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { DataGrid } from "@mui/x-data-grid";
import { makeStyles } from "@mui/styles";
import { ptBR } from "@mui/material/locale";

const theme = createTheme(ptBR);
export interface IProps {
    columns: any;
    rows: any[];
    rowId: any;
    rowCount?: number;
    isLoading?: boolean;
    onPageChange?: any;
    onPageSizeChange?: any;
    getRowClassName?: any;
    pageSize?: number;
    hideFooterPagination?: boolean;
    initialState?: any;
    checkboxSelection?: boolean;
    onRowSelectionModelChange?: any;
    rowSelectionModel?: any;
    onSortModelChange?: any;
    hideFooter?: any;
    disableRowSelectionOnClick?: any;
}

export default function DataTable(props: IProps) {
    const classes = useStyles();

    const handleIconSortableUp = () => {
        return (
            <Tooltip title="Menor">
                <Box style={{ display: "flex", flexDirection: "column" }}>
                    <ArrowDropUp style={{ color: "#F49E00", margin: "-8px 0px" }} />
                    <ArrowDropDown style={{ color: "#EC6E0C", margin: "-8px 0px" }} />
                </Box>
            </Tooltip>
        );
    };

    const handleIconSortableDown = () => {
        return (
            <Tooltip title="Maior">
                <Box style={{ display: "flex", flexDirection: "column" }}>
                    <ArrowDropUp style={{ color: "#EC6E0C", margin: "-8px 0px" }} />
                    <ArrowDropDown style={{ color: "#F49E00", margin: "-8px 0px" }} />
                </Box>
            </Tooltip>
        );
    };

    return (
        <ThemeProvider theme={theme}>
            <DataGrid
                paginationMode="server"
                sortingMode="server"
                columns={props.columns}
                rows={props.rows}
                getRowId={props.rowId}
                rowCount={props.rowCount}
                onPageChange={props.onPageChange}
                onPageSizeChange={props.onPageSizeChange}
                loading={props.isLoading}
                getRowClassName={props.getRowClassName ? props.getRowClassName : (params) => classes.background}
                disableColumnMenu
                localeText={{
                    columnHeaderSortIconLabel: "Ordenar",
                    footerRowSelected: (count) =>
                        count > 1 ? `${count} linhas selecionadas` : `${count} linha selecionada`,
                }}
                rowsPerPageOptions={[10, 25, 50, 100]}
                pageSize={props.pageSize}
                rowHeight={35}
                initialState={props.initialState}
                hideFooterPagination={props.hideFooterPagination}
                components={{
                    NoResultsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                            Nenhum resultado encontrado!
                        </Stack>
                    ),
                    NoRowsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                            Nenhum registro
                        </Stack>
                    ),
                    ColumnSortedDescendingIcon: handleIconSortableUp,
                    ColumnSortedAscendingIcon: handleIconSortableDown,
                }}
                checkboxSelection={props.checkboxSelection}
                onRowSelectionModelChange={props.onRowSelectionModelChange}
                rowSelectionModel={props.rowSelectionModel}
                onSortModelChange={props.onSortModelChange}
                hideFooter={props.hideFooter}
                disableRowSelectionOnClick={props.disableRowSelectionOnClick}
            />
        </ThemeProvider>
    );
}

const useStyles = makeStyles({
    background: {
        backgroundColor: "#ffffff",
    },
});
